import React from "react";
import classes from "./styles.module.scss";

const InputText = (props) => {
    return (
        <div className={classes.input_text}>
            <label htmlFor="text">{props.label}</label>
            {
                props.inputType == 'select' ? <>
                    <select {...props}>
                        <option value="">Select</option>
                        {
                            props.options?.map((o, i) => (
                                <option key={i} value={o.optionValue}>{o.optionLabel}</option>
                            ))
                        }
                    </select>
                </> :
                    <>
                        <input
                            id="text"
                            type="text"
                            value={props.value}
                            onChange={props.onChange}
                            placeholder={props.placeholder}
                            {...props}
                        />
                    </>
            }

        </div>
    )
}

export default InputText;